module.exports = __webpack_public_path__ + "img/流海APP.64606b94.png";